import { MainLayout } from "@/org-admins/layouts/MainLayout"
import React, { useState } from "react"
import ForgotPasswordCodeForm from "./components/ForgotPasswordCodeForm"
import ResetPasswordForm from "./components/ResetPasswordForm"
import UpdatePasswordForm from "./components/UpdatePasswordForm"

const ForgotPasswordScreen = () => {
  const [code, setCode] = useState("")
  const [email, setEmail] = useState("")

  if (!email)
    return (
      <MainLayout showLogo={true}>
        <ResetPasswordForm setEmail={setEmail} />
      </MainLayout>
    )

  return (
    <MainLayout showLogo={true}>
      {code ? (
        <UpdatePasswordForm email={email} code={code} />
      ) : (
        <ForgotPasswordCodeForm email={email} setCode={setCode} />
      )}
    </MainLayout>
  )
}

export default ForgotPasswordScreen
